import React, { useState, useEffect } from "react";
// Components
import Navbar from "../../components/Navbar";
import Lojas from "../../assets/navbar/Lojas_on_light_blue.svg";
import ListHistoryAgentStore from "../../components/ListHistoryAgentStore";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";
import api from "../../services/api";
import { useParams } from "react-router";

export default function HistoryAgentStore() {
  const [initialValues, setInitialValues] = useState({
    id: null,
    pessoaId: null,
    cpfCnpj: "",
    nome: "",
    nomeLoja: "",
  });
  const history = useHistory();
  const params = useQuery();
  const { id } = useParams();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  async function getDataByUserId() {
    const response = await api.get(`/api/loja/pessoa/${id}`);

    if (response?.data) {
      setInitialValues({
        ...initialValues,
        id: response?.data?.id,
        pessoaId: response?.data?.pessoa?.id,
        cpfCnpj: response?.data?.pessoa?.cpfCnpj,
        nome: response?.data?.pessoa?.nomeFantasia,
        nomeLoja: response?.data?.nomeLoja,
      });
    }
  }

  useEffect(() => {
    if (id) {
      getDataByUserId();
    }
  }, [id]);

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={Lojas} />
            <div>
              <S.Title>Histórico de Agentes</S.Title>
              <S.Description>{initialValues.nomeLoja}</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        <ListHistoryAgentStore
          filter={params.get("filter") || ""}
          state={params.get("uf") || ""}
          stateName={params.get("ufName") || ""}
          type={params.get("type") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
